define('lq/events/actions/executeEidReader',[
    'jquery',
    'lq',
    'underscore',
    'lq/events/actions/eventAction',
    'lq/util'
], function ($, lq, _, EventAction, util) {
    'use strict';

    var EidServiceUrl = 'http://localhost:31031/eid';
    var RequiredVersion = 2;

    function ExecuteEidReader(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExecuteEidReader);

    ExecuteEidReader.typeName = 'ExecuteEidReader';

    ExecuteEidReader.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExecuteEidReader.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    ExecuteEidReader.prototype.execute = function (continuation) {
        var self = this;

        fetch(EidServiceUrl, {
            mode: 'cors',
            method: 'GET'
        })
        .then(async function (response) {
            self.piping.busyIndicator.hide();
            try {
                if (response.json) {
                    var data = await response.json();
                    if (!response.ok) {
                        if (data.errorCode === 1) {
                            self.handleError('noCardReaderConnected', 'No card reader connected', continuation);
                        } else if (data.errorCode === 2) {
                            self.handleError('noCardInReader', 'No card in the reader', continuation);
                        } else if (data.errorCode === 3) {
                            self.handleError('moreThanOneCardDetected', 'More than one card detected', continuation);
                        } else if (data.errorCode === 4) {
                            self.handleError('eIDMiddlewareNotInstalled', 'e-ID middleware not installed' , continuation);
                        } else {
                            alert('eID-Reader error: ' + data.detail);
                        }
                    } else if (parseInt(data.version) < RequiredVersion) {
                        alert('Your eID-Reader version is: ' + data.version + ' but ' + RequiredVersion + ' is required');
                    } else {
                        self.executeMappings(self.getDecoratedData(data), self.eventData.eidMappings);
                    }
                } else {
                    alert('eID-Reader unknown error');
                }
            } finally {
                self.piping.busyIndicator.hide();
                continuation();
            }
        }, function (err) {
            self.piping.busyIndicator.hide();
            self.handleError('notRunning', 'The eID-Reader service is not running', continuation);
        });

        this.piping.busyIndicator.show();
    };

    var monthMap = [
        { expr: /JAN/, value: "01" },
        { expr: /FE(B|V)/, value: "02" },
        { expr: /MAAR|MARS|M.R/, value: "03" }, // impossible to tell what the umlaut will be encoded like
        { expr: /A(P|V)R/, value: "04" },
        { expr: /M(E|A)I/, value: "05" },
        { expr: /JUI?N/, value: "06" },
        { expr: /JUI?L/, value: "07" },
        { expr: /AUG|AOUT/, value: "08" },
        { expr: /SEPT?/, value: "09" },
        { expr: /O(K|C)T/, value: "10" },
        { expr: /NOV/, value: "11" },
        { expr: /DE(C|Z)/, value: "12" }
    ];

    var birthDateExpression = /(\d\d)\.?\s*(\S+)\.?\s*(\d{4})/;
    var validityDateExpression = /(\d\d)\.(\d\d)\.(\d{4})/;

    var valueConvertersByPath = {
        'id.date_of_birth': function (original, formatter) {
            var match = original.match(birthDateExpression);
            if (match) {
                var monthName = match[2];
                var monthEntry = _.find(monthMap, function (entry) { return entry.expr.test(monthName); });
                if (monthEntry) {
                    var date = new Date(Date.UTC(match[3], monthEntry.value - 1, match[1]));
                    //var date = formatter.parseLicquidDate(match[3] + '-' + monthEntry.value + '-' + match[1] + 'T00:00:00');
                    return date;
                }
            }
            return null;
        },
        'id.validity_begin_date': function (original, formatter) {
            var match = original.match(validityDateExpression);
            if (match) {
                var date = new Date(Date.UTC(match[3], match[2] - 1, match[1]));
                //var date = formatter.parseLicquidDate(match[3] + '-' + match[2] + '-' + match[1] + 'T00:00:00');
                return date;
            }
            return null;
        },
        'id.validity_end_date': function (original, formatter) {
            var match = original.match(validityDateExpression);
            if (match) {
                var date = new Date(Date.UTC(match[3], match[2] - 1, match[1]));
                //var date = formatter.parseLicquidDate(match[3] + '-' + match[2] + '-' + match[1] + 'T00:00:00');
                return date;
            }
            return null;
        },
        'id.gender': function (original) {
            if (original === "V" || original === "W")
                return "F";
            return original;
        },
        'address.address_street': function (original) {
            var indexOfNumber = original.search(/\d/);
            if (indexOfNumber < 0) return original;

            return original.substring(0, indexOfNumber).trim();
        },
        'address.address_number': function (original) {
            var indexOfNumber = original.search(/\d/);
            if (indexOfNumber < 0) return '';

            return original.substring(indexOfNumber).trim();
        }
    };

    ExecuteEidReader.prototype.executeMappings = function (data, eidMappings) {
        var self = this;

        var formatter = self.piping.formatting.createFormatter();

        _.each(eidMappings, function (mapping) {
            var sourcePath = mapping.sourcePath;

            if (sourcePath == 'address.address_street' || sourcePath == 'address.address_number')
                sourcePath = 'address.address_street_and_number';

            var value = util.getPropertyByPath(data, sourcePath);

            if (valueConvertersByPath[mapping.sourcePath])
                value = valueConvertersByPath[mapping.sourcePath](value, formatter);

            self.piping.parameters.locals.setValue(mapping.targetParameter, value);
        });

    };

    ExecuteEidReader.prototype.getDecoratedData = function (data) {
        data.photoBase64 = "data:image/png;base64, " + data.photoBase64;
        return data;
    };

    return ExecuteEidReader;
});
